/* Home Camelia et ses fleurs · sections cam-*.liquid · sans dépendance
   Horloge de 11h, statut d'ouverture (heure de Paris), tailles, ajout au panier (tiroir Dawn),
   étiquettes qui se balancent, vidéo chargée au clic. Inclus par plusieurs sections : une seule exécution. */
(() => {
  if (window.camHome) return;
  window.camHome = true;

  const reduit = matchMedia('(prefers-reduced-motion: reduce)');
  const $ = (sel, el = document) => el.querySelector(sel);
  const $$ = (sel, el = document) => [...el.querySelectorAll(sel)];
  const point = (deg, r) => { // cercle centré dans un viewBox 42×42, angle depuis midi
    const a = deg * Math.PI / 180;
    return `${(21 + r * Math.sin(a)).toFixed(2)} ${(21 - r * Math.cos(a)).toFixed(2)}`;
  };
  const JOURS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const NOMS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  const hm = (min) => `${Math.floor(min / 60)}h${min % 60 ? String(min % 60).padStart(2, '0') : ''}`;

  // Heure de Paris, quelle que soit celle de l'appareil (?cm_heure=09:36&cm_jour=Sat pour tester)
  function paris() {
    const q = new URLSearchParams(location.search);
    if (q.get('cm_heure')) {
      const [h, m] = q.get('cm_heure').split(':').map(Number);
      return { j: JOURS.indexOf(q.get('cm_jour') || 'Sat'), h, m };
    }
    const p = Object.fromEntries(new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Paris', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23',
    }).formatToParts(new Date()).map((x) => [x.type, x.value]));
    return { j: JOURS.indexOf(p.weekday), h: Number(p.hour), m: Number(p.minute) };
  }

  /* ---------- Horloge de 11h (héros) ---------- */
  function horloge(boite) {
    const cadran = $('[data-cm-cadran]', boite);
    const compte = $('[data-cm-compte]', boite);
    const limite = Number(boite.dataset.limite || 11) * 60;
    const angleL = ((limite / 60) % 12) * 30;
    $('.cm-cadran-limite', cadran).setAttribute('d', `M${point(angleL, 17.5)}L${point(angleL, 15)}`);
    const maj = () => {
      const { j, h, m } = paris();
      const reste = limite - (h * 60 + m);
      const livrable = j !== 1 && reste > 0; // livraisons du mardi au dimanche
      const angleH = ((h % 12) + m / 60) * 30;
      $('.cm-cadran-h', cadran).setAttribute('transform', `rotate(${angleH} 21 21)`);
      $('.cm-cadran-m', cadran).setAttribute('transform', `rotate(${m * 6} 21 21)`);
      const secteur = $('.cm-cadran-secteur', cadran);
      if (livrable && angleH < angleL) {
        secteur.setAttribute('d', `M21 21L${point(angleH, 17)}A17 17 0 ${angleL - angleH > 180 ? 1 : 0} 1 ${point(angleL, 17)}Z`);
      } else secteur.setAttribute('d', '');
      compte.textContent = !livrable ? '' : reste >= 60 ? `encore ${Math.floor(reste / 60)} h ${String(reste % 60).padStart(2, '0')}` : `encore ${reste} min`;
    };
    maj();
    setInterval(maj, 30000);
  }

  /* ---------- Statut d'ouverture (boutique) ---------- */
  function statut(section) {
    const el = $('[data-cm-statut]', section);
    const horaires = JSON.parse(section.dataset.horaires || '{}');
    const plages = (j) => horaires[j] || [];
    const maj = () => {
      const { j, h, m } = paris();
      const min = h * 60 + m;
      const plage = plages(j).find(([a, b]) => min >= a && min < b);
      let texte;
      if (plage) texte = `Ouvert jusqu’à ${hm(plage[1])}`;
      else {
        const suite = plages(j).find(([a]) => a > min);
        if (suite) texte = `Fermé, réouverture à ${hm(suite[0])}`;
        else {
          let k = 1;
          while (k < 7 && !plages((j + k) % 7).length) k++;
          texte = k < 7 ? `Fermé, réouverture ${k === 1 ? 'demain' : NOMS[(j + k) % 7]} à ${hm(plages((j + k) % 7)[0][0])}` : 'Fermé';
        }
      }
      el.classList.toggle('is-ouvert', Boolean(plage));
      $('span', el).textContent = texte;
      $$('[data-jours]', section).forEach((dt) => {
        const ok = dt.dataset.jours.split(',').map(Number).includes(j);
        dt.classList.toggle('is-aujourdhui', ok);
        dt.nextElementSibling?.classList.toggle('is-aujourdhui', ok);
      });
    };
    maj();
    setInterval(maj, 30000);
  }

  /* ---------- Message de repli (si le thème n'a ni tiroir ni notification) ---------- */
  let toast = null, minuteur = 0;
  function annoncer(html) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'cm cm-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.append(toast);
    }
    toast.innerHTML = html;
    toast.classList.add('is-visible');
    clearTimeout(minuteur);
    minuteur = setTimeout(() => toast.classList.remove('is-visible'), 4236); // φ³ s
  }

  /* ---------- Tailles et panier ---------- */
  document.addEventListener('change', (e) => {
    const radio = e.target.closest('.cm input[data-prix]');
    if (radio) $('[data-cm-prix]', radio.closest('[data-cm-produit]')).textContent = radio.dataset.prix;
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.cm [data-cm-achat]');
    if (!form) return;
    e.preventDefault();
    const bouton = $('button[type="submit"]', form);
    if (bouton.classList.contains('is-attente')) return;
    const carte = form.closest('[data-cm-produit]');
    const texte = $('[data-bouton-texte]', bouton);
    const id = Number(new FormData(form).get('id'));
    const panier = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const sections = panier?.getSectionsToRender ? panier.getSectionsToRender().map((s) => s.id) : ['cart-icon-bubble'];
    bouton.classList.add('is-attente');
    texte.textContent = 'Ajout…';
    try {
      const r = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id, quantity: 1, sections, sections_url: location.pathname }),
      });
      const rep = await r.json();
      if (rep.status) throw new Error(rep.description || rep.message || 'refus');
      bouton.classList.replace('is-attente', 'is-ajoute');
      texte.textContent = 'Ajouté';
      if (panier?.renderContents) {
        // même enchaînement que le formulaire produit de Dawn : le tiroir s'ouvre avec le bouquet ajouté
        panier.classList.remove('is-empty');
        panier.renderContents(rep);
      } else {
        const bulle = document.getElementById('cart-icon-bubble');
        const html = rep.sections?.['cart-icon-bubble'];
        if (bulle && html) bulle.innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section')?.innerHTML || bulle.innerHTML;
        annoncer(`Ajouté au panier : ${rep.product_title}${rep.variant_title ? `, taille ${rep.variant_title}` : ''}. <a href="${window.routes?.cart_url || '/cart'}" class="cm-insecable">Voir le panier</a>`);
      }
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'cam-home', productVariantId: id, cartData: rep });
      secousse(carte);
      setTimeout(() => { bouton.classList.remove('is-ajoute'); texte.textContent = 'Ajouter'; }, 2618); // φ² s
    } catch (err) {
      bouton.classList.remove('is-attente');
      texte.textContent = 'Ajouter';
      annoncer(`Le bouquet n’a pas été ajouté : ${err.message}. Réessayez.`);
    }
  });

  /* ---------- Vidéo chargée au clic ---------- */
  document.addEventListener('click', (e) => {
    const bouton = e.target.closest('.cm [data-cm-video] button');
    if (!bouton) return;
    const boite = bouton.closest('[data-cm-video]');
    const v = document.createElement('video');
    Object.assign(v, { src: boite.dataset.src, controls: true, autoplay: true, playsInline: true, preload: 'auto' });
    v.setAttribute('aria-label', boite.dataset.titre || 'Vidéo');
    boite.replaceChildren(v);
    v.play().catch(() => {}); // dans le geste du clic : la lecture démarre même sur mobile
    v.focus();
  });

  /* ---------- Étiquettes qui se balancent ---------- */
  // Pendule amorti par étiquette : période φ s, amortissement φ⁻³, amplitude bornée à φ⁴ degrés.
  const P = { w: 2 * Math.PI / 1.618, z: 0.236, max: 6.854 };
  const etals = [];
  let raf = 0, dernier = 0;
  function image(maintenant) {
    const dt = Math.min((maintenant - dernier) / 1000, 1 / 30);
    dernier = maintenant;
    let actif = false;
    for (const e of etals) {
      e.vRail *= Math.exp(-dt * 6.18);
      const cible = -Math.max(-P.max, Math.min(P.max, e.vRail * 4.236));
      if (Math.abs(e.vRail) > 0.002) actif = true;
      for (const it of e.items) {
        it.v += (-P.w * P.w * (it.t - cible) - 2 * P.z * P.w * it.v) * dt;
        it.t += it.v * dt;
        if (Math.abs(it.t) > P.max) { it.t = Math.sign(it.t) * P.max; it.v *= -0.382; }
        it.eti.style.transform = `rotate(${(it.repos + it.t).toFixed(3)}deg)`;
        if (Math.abs(it.t - cible) > 0.01 || Math.abs(it.v) > 0.01) actif = true;
      }
    }
    raf = actif ? requestAnimationFrame(image) : 0;
  }
  const lancer = () => { if (!raf && !reduit.matches) { dernier = performance.now(); raf = requestAnimationFrame(image); } };
  let secousse = (carte) => {
    for (const e of etals) {
      const it = e.items.find((x) => x.li === carte);
      if (it) { it.v += 61.8; lancer(); }
    }
  };

  function etal(section) {
    const rail = $('[data-cm-rail]', section);
    const rangee = $('[data-cm-rangee]', section);
    if (!rail || !rangee) return;
    const prog = $('.cm-progression', section);
    // largeur réelle d'une colonne, pour caler la ficelle sur le raphia
    new ResizeObserver(() => {
      const w = rangee.firstElementChild?.getBoundingClientRect().width;
      if (w) rangee.style.setProperty('--col', `${w}px`);
      majRail();
    }).observe(rangee);
    function majRail() {
      if (!prog) return;
      const max = rail.scrollWidth - rail.clientWidth;
      prog.style.setProperty('--visible', max > 2 ? (rail.clientWidth / rail.scrollWidth).toFixed(4) : 1);
      prog.style.setProperty('--avance', max > 2 ? (rail.scrollLeft / max).toFixed(4) : 0);
    }
    rail.addEventListener('scroll', majRail, { passive: true });
    if (reduit.matches) return;

    const e = {
      vRail: 0,
      items: $$('.cm-bq', rangee).map((li) => ({ li, eti: $('.cm-bq__etiquette', li), repos: parseFloat(li.style.getPropertyValue('--repos')) || 0, t: 0, v: 0 })),
    };
    etals.push(e);
    let xRail = rail.scrollLeft, tRail = 0;
    rail.addEventListener('scroll', () => {
      const t = performance.now();
      const dtms = Math.max(t - tRail, 8);
      const v = (rail.scrollLeft - xRail) / dtms;
      xRail = rail.scrollLeft; tRail = t;
      if (dtms < 100) e.vRail += (v - e.vRail) * 0.382;
      lancer();
    }, { passive: true });
    // souris qui passe vite : impulsion au carré de la vitesse, un pointeur lent ne fait rien
    let px = 0, pt = 0;
    rangee.addEventListener('pointermove', (ev) => {
      if (ev.pointerType !== 'mouse') return;
      const t = performance.now();
      const dtp = Math.max(t - pt, 8);
      const vx = (ev.clientX - px) / dtp;
      px = ev.clientX; pt = t;
      if (Math.abs(vx) < 0.15 || dtp > 100) return;
      for (const it of e.items) {
        const r = it.eti.getBoundingClientRect();
        if (ev.clientY < r.top - r.height || ev.clientY > r.bottom) continue;
        const f = 1 - Math.abs(ev.clientX - (r.left + r.width / 2)) / (r.width * 0.618);
        if (f <= 0) continue;
        it.v = Math.max(-60, Math.min(60, it.v - 13 * vx * Math.abs(vx) * f * (dtp / 16.7)));
      }
      lancer();
    });
    // à l'arrivée à l'écran, une bouffée de vent traverse la rangée (décalage φ⁻⁴ s)
    new IntersectionObserver((entrees, obs) => {
      if (!entrees.some((x) => x.isIntersecting)) return;
      obs.disconnect();
      e.items.forEach((it, i) => setTimeout(() => { it.v -= 34; lancer(); }, i * 146));
    }, { threshold: 0.2 }).observe(rangee);
  }

  function initialiser(racine = document) {
    $$('[data-cm-horloge]', racine).forEach(horloge);
    $$('[data-cm-boutique]', racine).forEach(statut);
    $$('[data-cm-etal]', racine).forEach(etal);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialiser());
  else initialiser();
  // éditeur de thème : une section rechargée se réinitialise seule
  document.addEventListener('shopify:section:load', (e) => initialiser(e.target));
})();
